__turbopack_context__.v({
  "wrapper": "LearnMore-module-scss-module__Js_nFW__wrapper",
});
